import React from 'react';
import './ReglesRegulation.css';


const ReglesRegulation= () => {
    return ( 
        <div className='mererr'>

        <div className='containerArr'>
            
            <div className='barresrr'>
            <div className='trait1rr'></div>
            <div className='trait2rr'></div>
            </div>
            <div className='titrerr'>
                <h1>REGLES ET REGULATIONS</h1>
            </div>
            <div className='ligne5rr'>
            </div>
            </div>
            <div className='texterr'>
            <p> Les projets de construction ou de rénovation doivent respecter les règles d’urbanisme définies par le Code de l'Urbanisme gabonais :</p>
            <h6>
            LIMITE DE HAUTEUR:
            </h6>
            <p>
            * Dans les zones résidentielles, la hauteur des bâtiments ne doit pas dépasser 15 mètres, sauf dérogation spéciale.
            </p>
            
           <h6>
           DISTANCE MINIMALE: 
            </h6>
            <p>
            * Une distance de 3 mètres doit être respectée entre une construction et la limite de propriété voisine, conformément aux articles 32 et 33 du Règlement d'Urbanisme.
            </p>

            <h6>
            RESPECT DE L’ENVIRONNEMENT: 
            </h6>
            <p>
            * Toute construction située à proximité des mangroves ou des zones sensibles doit respecter des normes strictes en matière de protection environnementale (article 12 du Code de l'Environnement gabonais).
            </p>
           </div>
           
    </div>
    
    );
};

export default ReglesRegulation;
